__turbopack_context__.v({
  "cardDesc": "DmsLifecycle-module__eb7r2q__cardDesc",
  "cardTitle": "DmsLifecycle-module__eb7r2q__cardTitle",
  "content": "DmsLifecycle-module__eb7r2q__content",
  "drawSpine": "DmsLifecycle-module__eb7r2q__drawSpine",
  "eyebrow": "DmsLifecycle-module__eb7r2q__eyebrow",
  "growLine": "DmsLifecycle-module__eb7r2q__growLine",
  "head": "DmsLifecycle-module__eb7r2q__head",
  "icon": "DmsLifecycle-module__eb7r2q__icon",
  "inView": "DmsLifecycle-module__eb7r2q__inView",
  "item": "DmsLifecycle-module__eb7r2q__item",
  "left": "DmsLifecycle-module__eb7r2q__left",
  "no": "DmsLifecycle-module__eb7r2q__no",
  "node": "DmsLifecycle-module__eb7r2q__node",
  "nodePulse": "DmsLifecycle-module__eb7r2q__nodePulse",
  "right": "DmsLifecycle-module__eb7r2q__right",
  "section": "DmsLifecycle-module__eb7r2q__section",
  "slideInLeft": "DmsLifecycle-module__eb7r2q__slideInLeft",
  "slideInRight": "DmsLifecycle-module__eb7r2q__slideInRight",
  "subtitle": "DmsLifecycle-module__eb7r2q__subtitle",
  "tagline": "DmsLifecycle-module__eb7r2q__tagline",
  "timeline": "DmsLifecycle-module__eb7r2q__timeline",
  "title": "DmsLifecycle-module__eb7r2q__title",
});
